module.exports = __webpack_public_path__ + "img/collection-engagementRingsPlatinum.1f51cb3.webp";